var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowCircleLeftDisabled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-circle-left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Evo-Portal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit-columns",
    transform: "translate(-953.000000, -525.000000)",
    fill: "#C4CDD6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-circle-left",
    transform: "translate(953.000000, 525.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C5.37258302,0 0,5.37258302 0,12 C0,18.6274171 5.37258302,24 12,24 C18.6274171,24 24,18.6274171 24,12 C23.9928353,5.37555307 18.624447,0.00716484764 12,0 Z M15.9060001,17.0080001 C16.2639538,17.278483 16.449493,17.7200576 16.3921586,18.1650347 C16.3348243,18.6100118 16.0434114,18.9901322 15.628585,19.161044 C15.2137585,19.3319558 14.7391525,19.2674413 14.3850001,18.9920001 L7.03900003,13.3580001 C6.61654937,13.0342111 6.3688444,12.532263 6.3688444,12.0000001 C6.3688444,11.4677371 6.61654937,10.965789 7.03900003,10.642 L14.3850001,5.00800002 C14.7391525,4.73255877 15.2137585,4.66804429 15.628585,4.83895612 C16.0434114,5.00986794 16.3348243,5.3899883 16.3921586,5.83496541 C16.449493,6.27994252 16.2639538,6.72151713 15.9060001,6.99200003 L9.63500004,11.8 C9.57167022,11.8469678 9.53432738,11.9211544 9.53432738,12.0000001 C9.53432738,12.0788457 9.57167022,12.1530323 9.63500004,12.2000001 L15.9060001,17.0080001 Z",
    id: "icon/arrow-circle-left"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleLeftDisabled);
export default __webpack_public_path__ + "static/media/arrow-circle-left-disabled.02bb8849468a4a8629cb60589118f007.svg";
export { ForwardRef as ReactComponent };